// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1K205","row":"styles_row__3mmMg"};